const KeyValue = {
    key_name: "",
    value: "",
    date: new Date().toISOString().split('T')[0],
  };
  
  export default KeyValue;
  